import React from 'react';

import Box from 'components/elements/Box';

import { Checkbox, Slider, Text, Wrapper } from './styles';

interface ISwitcherProps {
  componentName?: string;
  isChecked: boolean;
  leftLabel?: string;
  rightLabel?: string;
  setCheck: Function;
  isWithoutMargins?: boolean;
  disabled?: boolean;
  isToggleSwitcher?: boolean;
}

const Switcher: React.FC<ISwitcherProps> = ({
  componentName,
  isChecked,
  leftLabel,
  rightLabel,
  setCheck,
  isWithoutMargins,
  disabled,
  isToggleSwitcher = false,
}) => {
  const setView =
    (param: boolean): any =>
    (): void =>
      setCheck(param);
  const changeCheckboxValue = (): void => setCheck(!isChecked);

  return (
    <Wrapper componentName={componentName} isWithoutMargins={isWithoutMargins}>
      {leftLabel && (
        <Text
          isActive={isChecked}
          onClick={setView(true)}
          componentName={componentName}
        >
          {leftLabel}
        </Text>
      )}
      <Box
        height="18px"
        width="35px"
        display="inline-block"
        position="relative"
      >
        <Checkbox
          type="checkbox"
          role="switch"
          onChange={changeCheckboxValue}
          checked={!isChecked}
          disabled={disabled}
        />
        <Slider
          onClick={changeCheckboxValue}
          isActive={!disabled}
          isToggleSwitcher={isToggleSwitcher}
          isChecked={!isChecked}
        />
      </Box>
      <Text
        isActive={!isChecked}
        onClick={setView(false)}
        componentName={componentName}
      >
        {rightLabel}
      </Text>
    </Wrapper>
  );
};

export default Switcher;
